// Fetches the LLM/embedding model catalog from the backend.
//
// The backend owns the spec for each supported model — temperature,
// reasoning_effort, max_tokens etc. are all locked there. The UI just shows
// the user a Select, takes their pick, and stores the model id.

import { buildApiUrl } from '../config';

export type ChatModelOption = {
  id: string;
  label: string;
  provider: 'openai' | 'anthropic' | 'google' | 'azure-openai';
  description: string;
  is_reasoning_model: boolean;
  is_default: boolean;
};

export type EmbeddingModelOption = {
  id: string;
  label: string;
  provider: 'openai' | 'anthropic' | 'google' | 'azure-openai';
  dimensions: number;
  description: string;
  is_default: boolean;
};

export type ModelCatalog = {
  chat_models: ChatModelOption[];
  embedding_models: EmbeddingModelOption[];
  defaults: { chat_model_id: string; embedding_model_id: string };
};

const authHeaders = (): Record<string, string> => {
  const token = window.localStorage.getItem('klaris_jwt');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function fetchModelCatalog(tenantId: string): Promise<ModelCatalog> {
  const resp = await fetch(
    buildApiUrl(`/api/v1/tenants/${tenantId}/ai-settings/model-catalog`),
    { headers: authHeaders(), cache: 'no-store' } as RequestInit,
  );
  const data = await resp.json();
  if (!resp.ok) throw new Error(data?.detail || 'Failed to load model catalog');
  return data as ModelCatalog;
}
